var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-paperclip-3839817 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.43755 19.6875C7.44335 19.6864 6.49022 19.291 5.78705 18.588C5.08405 17.8849 4.68862 16.9317 4.6875 15.9375V5.62498C4.6875 4.216 5.2472 2.86482 6.24348 1.86848C7.23977 0.87215 8.59098 0.3125 9.99998 0.3125C11.409 0.3125 12.7601 0.8722 13.7565 1.86848C14.7528 2.86477 15.3125 4.21598 15.3125 5.62498V15.9375H14.0625V5.62498C14.0625 4.54752 13.6345 3.51432 12.8726 2.75232C12.1107 1.9904 11.0774 1.5624 9.99988 1.5624C8.92238 1.5624 7.88922 1.9904 7.12722 2.75232C6.3653 3.51417 5.9373 4.54748 5.9373 5.62498V15.9375C5.9373 16.8307 6.4138 17.656 7.1873 18.1025C7.9608 18.5491 8.9138 18.5491 9.6873 18.1025C10.4608 17.6559 10.9373 16.8306 10.9373 15.9375V5.62498C10.9373 5.29002 10.7586 4.98058 10.4685 4.81307C10.1785 4.64562 9.82108 4.64562 9.53105 4.81307C9.24102 4.98058 9.0623 5.29002 9.0623 5.62498V15.9375H7.8123V5.62498C7.8123 4.84347 8.22923 4.12133 8.90605 3.73065C9.58287 3.33983 10.4167 3.33983 11.0935 3.73065C11.7704 4.1214 12.1873 4.84353 12.1873 5.62498V15.9375C12.1862 16.9317 11.7908 17.8848 11.0878 18.588C10.3847 19.291 9.4315 19.6864 8.43725 19.6875H8.43755Z",
    fill: "#595858"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/Paperclip.4ca83ba53468e9cf7b2693a0221d9bbe.svg";
export { ForwardRef as ReactComponent };